import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { BASE_URL } from '../../../../shared/constants';
import ProductDiscountImage from '../../../ProductDiscountImage';

/**
 * Мініатюра товару; клік — повноекранний перегляд (поверх модалок збірки).
 */
export function ScannerPickImageWithLightbox({ imagePath, alt = '', size = 48, price, discountedPrice, personalDiscount, productDiscount }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!imagePath) return null;

  const src = `${BASE_URL}/api/v1/product/image/${imagePath}`;

  const lightbox =
    open &&
    createPortal(
      <div
        role='presentation'
        onClick={() => setOpen(false)}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10600,
          background: 'rgba(0,0,0,0.94)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '12px',
        }}
      >
        <button
          type='button'
          className='close text-white border-0 bg-transparent position-fixed p-2'
          style={{ top: 8, right: 8, fontSize: '2.25rem', lineHeight: 1, opacity: 0.95, zIndex: 10601 }}
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
          }}
          aria-label='Закрити фото'
        >
          <span aria-hidden='true'>&times;</span>
        </button>
        <img
          src={src}
          alt={alt}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </div>,
      document.body
    );

  return (
    <>
      <ProductDiscountImage price={price} discountedPrice={discountedPrice}
        personalDiscount={personalDiscount} productDiscount={productDiscount}>
        <button
          type='button'
          className='btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center flex-shrink-0'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          }}
          aria-label='Відкрити фото на весь екран'
        >
          <img
            src={src}
            alt=''
            className='rounded border bg-white'
            style={{
              width: size,
              height: size,
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </button>
      </ProductDiscountImage>
      {lightbox}
    </>
  );
}
